import { BrowserRouter as Router } from "react-router-dom";
import { ReactNode } from "react";
import { AxiosInterceptor } from "../../utils/axiosConfig";
import ChatbotProvider from "./ChatbotProvider";
import SessionProvider from "./SessionProvider";
import SessionTimeoutProvider from "./SessionTimeoutContext";
import StatusProvider from "./StatusProvider";
import { UrlParamsProvider } from "./UrlParamProvider";
import { Provider, ErrorBoundary } from "@rollbar/react";
import { rollbarConfig } from "../../rollbarConfig";
import { TenantThemeApplier } from "../Theme/TenantThemeApplier";

export const GlobalProvider = ({ children }: { children: ReactNode }) => {
	return (
		<Provider config={rollbarConfig}>
			<ErrorBoundary>
				<TenantThemeApplier>
					<Router>
						<UrlParamsProvider>
							<SessionProvider>
								<StatusProvider>
									<SessionTimeoutProvider>
										<AxiosInterceptor>
											<ChatbotProvider>{children}</ChatbotProvider>
										</AxiosInterceptor>
									</SessionTimeoutProvider>
								</StatusProvider>
							</SessionProvider>
						</UrlParamsProvider>
					</Router>
				</TenantThemeApplier>
			</ErrorBoundary>
		</Provider>
	);
};
